module.exports = __webpack_public_path__ + "files/35ba346edc3c214f13a263f23ac6867b.png";